const { COLORS } = require('./constants');

/**
 * Converts a named color string into hex string
 * @param {String} color- named color string
 * @returns {Object}
 */
const convertNamedColorToHex = (color) => color && COLORS[color.toLowerCase()];

module.exports = convertNamedColorToHex;
